export default __webpack_public_path__ + "static/media/Yelpcamp.4947897e.png";